export enum IntroductionStatus {
  PENDING = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  EXPIRED = 4,
  PAYMENT_ON_HOLD = 5,
}

export type IntroductionRequest = {
  id: number;
  requester: {
    avatar: string;
    username: string;
    tier: string | null;
  };
  recipent: {
    avatar: string;
    username: string;
    tier: string | null;
  };
  dateRequest: string; // ISO 8601
  dateExpires: string;
  status: "PENDING" | "ACCEPTED" | "REJECTED" | "EXPIRED" | "PAYMENT_ON_HOLD";
  type: string;
  topic: string;
  message: string;
  relation: "sender" | "receiver"
};

export type IntroductionRequestList = IntroductionRequest[];